import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Form,
  Row,
  Col,
  FormGroup,
  Container,
  CardBody,
  Card
} from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumb from "../../../common/Breadcrumb/Breadcrumb";
import Loader from "../../../common/Loader";
import Pointgraph from '../../../_dashboard/components/point_graph';
import {
  useLazyGetCollectionListQuery,
  useLazyGetCollectionVideoListQuery,
  useLazyGetContentPartnerListQuery,
  useLazyGetEpisodeListQuery,
  useLazyGetShowListQuery,
  useLazyGetVideoListQuery,
  useLazyGetVodAnalyticsReportDefaultQuery,
  useLazyGetVodAnalyticsReportFilterQuery,
  useLazyGetVodAnalyticsReportGraphQuery,
} from "../../../../store/api/userManagementApi";
import { ExportCSV } from '../../components/export_excel'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import dateFormatter from "date-and-time";
import FilterItems from "../../components/filterItems";
import { addDays } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import moment from "moment";
import DateRange from "../../../DateRangePicker/DateRange";
import ReactSelect from 'react-select';
import { Tabs, Tab } from "react-bootstrap";
import FiltersRow from "../../components/filters_row";
import { filters } from "../../filters";
import SearchCity from "../../components/search_city";

const UserAnalytics = (props) => {
  const storedUserData = useSelector(state => state.userManagement.userData) || {};
  const routeUserData = props?.location?.state?.values || {};
  const userData = routeUserData?.user_id ? routeUserData : storedUserData;
  const user_id = userData?.user_id;
  const name = userData?.user_email || "—";
  const report = props?.location?.state?.userReport;
  const groupMemberView = props?.groupMemberView;
  const returnPath = props?.location?.state?.returnPath || (groupMemberView ? "/group/member-details/profile" : (report ? "/report/userdetail_report" : "/operations/UserManagment"));
  const returnState = props?.location?.state?.userDetailReportState;
  const [triggerReportFilter] = useLazyGetVodAnalyticsReportFilterQuery();
  const [triggerGraphReport] = useLazyGetVodAnalyticsReportGraphQuery();
  const [triggerDefaultReport] = useLazyGetVodAnalyticsReportDefaultQuery();
  const [triggerShowList] = useLazyGetShowListQuery();
  const [triggerVideoList] = useLazyGetVideoListQuery();
  const [triggerContentPartnerList] = useLazyGetContentPartnerListQuery();
  const [triggerCollectionList] = useLazyGetCollectionListQuery();
  const [triggerEpisodeList] = useLazyGetEpisodeListQuery();
  const [triggerCollectionVideoList] = useLazyGetCollectionVideoListQuery();

  const service = {
    ReportFilter: (pub_id, data, _reportType, inputUserId) =>
      triggerReportFilter({ pubId: pub_id, data, userId: inputUserId })
        .unwrap()
        .catch(() => false),
    VodAnalyticsReportGraph: (pub_id, data, filterData, inputUserId) =>
      triggerGraphReport({ pubId: pub_id, channels: data, filter: filterData, userId: inputUserId })
        .unwrap()
        .catch(() => ({ data: false })),
    VodAnalyticsReportDefault: (pub_id, data, inputUserId) =>
      triggerDefaultReport({ pubId: pub_id, channels: data, userId: inputUserId })
        .unwrap()
        .catch(() => false),
    getShowList: pub_id => triggerShowList(pub_id).unwrap().catch(() => false),
    getVideoList: pub_id => triggerVideoList(pub_id).unwrap().catch(() => false),
    getCollectionList: pub_id => triggerCollectionList(pub_id).unwrap().catch(() => false),
    getEpisodeList: pub_id => triggerEpisodeList(pub_id).unwrap().catch(() => false),
    getCollectionVideoList: pub_id =>
      triggerCollectionVideoList(pub_id).unwrap().catch(() => false),
    getContentPartner: channelId =>
      triggerContentPartnerList(channelId).unwrap().catch(() => false),
  };

  const [loader, setLoader] = useState(true);
  const [loaderTable, setLoaderTable] = useState(true);
  const [vodanalyticsReportGraphData, setvodanalyticsReportGraphData] =
    useState({ xAxis: [], yAxis: [] });
  const [vodanalyticsViewReportGraphData, setvodanalyticsViewReportGraphData] =
    useState({ xAxisView: [], yAxisView: [] });
  const [vodanalyticsReport, setvodanalyticsReport] = useState([]);
  const [flag, setFlag] = useState(false);
  const [summary, setSummary] = useState({ minutes: 0, views: 0 });

  const [activeTriger, setActiveTrigger] = useState(false);
  var [triger, setTriger] = useState(false);
  const [filterNew, setNewFilter] = useState({});
  const [contentPartnerList, setContentPartnerList] = useState([]);
  const [values, setValues] = useState({});
  const [hideColumn, setHideColumn] = useState(false);
  const [mediaId, setMediaId] = useState(false);
  const [dateRange, setDateRange] = useState([{ endDate: moment().toDate(), startDate: moment().subtract(6, 'day').toDate(), key: "rollup", },]);
  // aggregate
  // channel colum configurations
  const [showChannelColum, setChannelShowColumn] = useState(false);
  function channelFilterColumnConfig() {
    var publisherChannels = JSON.parse(localStorage.getItem("publisherConfig"));
    const channelConfig = publisherChannels;
    //console.log('zzz', channelConfig)
    var showColumConfigure = channelConfig.filter((element) => {
      if (element.key_name) {
        return element.key_name === "vod_analytics_channel_filter";
      } else {
        return [];
      }
    });
    if (showColumConfigure.length !== 0) {
      if (
        showColumConfigure[0]?.key_name === "vod_analytics_channel_filter" &&
        showColumConfigure[0]?.key_value === "True"
      ) {
        setChannelShowColumn(true);
      } else {
        setChannelShowColumn(false);
      }
    }
  }
  const getChannelConfigInfo = (keyName) => {
    let response = false;
    let configInfo =
      values?.channelConfig &&
      values?.channelConfig.filter((i) => keyName == i.key_name);
    response = configInfo && configInfo[0] && configInfo[0].key_value;
    return response;
  };

  // //// Global channel config /////////////
  const globalChannelConfig = (data) => {
    var publisherChannels = JSON.parse(localStorage.getItem("channelConfig"));
    if (publisherChannels) {
      var channelObject = publisherChannels.filter((item) => {
        return localStorage.getItem("currentChannel") == item.channel_id;
      });

      if (channelObject.length !== 0) {
        var channelConfig = [];
        channelConfig = channelObject[0] && channelObject[0].config;
        setValues({
          ...values,
          channelConfig: channelConfig,
        });
        setFilter({
          ...filter,
          channel: {
            value: 1,
            label: channelObject?.[0]?.channel_name,
            channel_id: channelObject?.[0]?.channel_id,
          },
        });
        setChannel(data);
      } else {
        setChannel(data);
        setFilter({
          ...filter,
          channel: data[0],
        });
      }
    }
  };

  // //// Global channel config /////////////
  const handleSubmit = (e, updatedFilter = null) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }

    setLoaderTable(true);
    setCalenderOpen(false);
    if (activeTriger) {
      setTriger(!triger);
    }

    const currentFilter = updatedFilter || filter;

    const start_date = moment(dateRange[0].startDate).format("YYYY-MM-DD");
    const end_date = moment(dateRange[0].endDate).format("YYYY-MM-DD");

    const apiPayload = {
      ...currentFilter,
      start_date,
      end_date,
      country: currentFilter.country || { value: 1, label: "All" },
      channel: currentFilter.channel || {},
      appType: currentFilter.appType || { value: 1, label: "All", app_type: null, id: null },
      paymentMode: currentFilter.paymentMode || { value: 1, label: "All" },
      publishers: currentFilter.publishers || { value: 1, label: "ALL", pubid: null },
      city: currentFilter.city || { value: 1, label: "All" },
      subType: currentFilter.subType || { value: 1, label: "All", subscription_type_id: null },
      show: currentFilter.show || { value: 1, label: "All", id: null },
      video: currentFilter.video || { value: 1, label: "All", id: null },
      collection: currentFilter.collection || { value: 1, label: "All", id: null },
      episode: currentFilter.episode || { value: 1, label: "All", id: null },
      collectionVideo: currentFilter.collectionVideo || { value: 1, label: "All", id: null },
      contentPartner: currentFilter.contentPartner || { value: 1, label: "All", content_partner_id: null },

      isChannelsSelected: currentFilter.channel !== null,
      isChannelSelected: currentFilter.channel !== null,
      isCountrySelected: currentFilter.country !== null,
      isAppSelected: currentFilter.appType !== null,
      isPublisherSelected: currentFilter.publishers !== null,
      isVideoChecked: currentFilter.video !== null,
      isCitySelected: currentFilter.city !== null,
      isShowchecked: currentFilter.show !== null,
      isCollectionchecked: currentFilter.collection !== null,
      isEpisodeChecked: currentFilter.episode !== null,
      isCollectionVideoChecked: currentFilter.collectionVideo !== null,
      isContentPartnerSelected: currentFilter.contentPartner !== null,
      isMediaIdSelected: currentFilter.isMediaIdSelected || false,
      isMonthlySelected: currentFilter.isMonthlySelected || false,
      isAggregateSelected: currentFilter.isAggregateSelected || false
    };

    service
      .ReportFilter(
        localStorage.getItem("pub_id"),
        apiPayload,
        "vodanalytics_report",
        user_id
      )
      .then((response) => {
        if (response && response.data) {
          setCountry(apiPayload.isCountrySelected);
          setApp(apiPayload.isAppSelected);
          setChannels(apiPayload.isChannelsSelected);
          setVideos(apiPayload.isVideoChecked);
          setShows(apiPayload.isShowchecked);
          setEpisodes(apiPayload.isEpisodeChecked);
          setCollections(apiPayload.isCollectionchecked);
          setCollectionVideos(apiPayload.isCollectionVideoChecked);
          setContentPartnerSelected(apiPayload.isContentPartnerSelected);
          setMediaId(apiPayload.isMediaIdSelected);
          setHideColumn(apiPayload.isAggregateSelected);

          setvodanalyticsReport(response.data);
        } else {
          setvodanalyticsReport([]);
          console.error("No data returned from API");
        }
        setLoaderTable(false);
      })
      .catch((error) => {
        console.error("Error fetching report data:", error);
        setvodanalyticsReport([]);
        setLoaderTable(false);
      });

    if (activeTriger || !vodanalyticsReportGraphData.xAxis.length) {
      setLoader(true);

      const channelParam = apiPayload.channel && Object.keys(apiPayload.channel).length > 0 ?
        [apiPayload.channel] : [];

      service
        .VodAnalyticsReportGraph(
          localStorage.getItem("pub_id"),
          channelParam,
          !activeTriger ? filterNew : null,
          user_id
        )
        .then((response) => {
          if (response && response.data) {
            let xAxis = [];
            let yAxis = [];
            let xAxisView = [];
            let yAxisView = [];

            response.data.forEach((element) => {
              yAxis.push(element.duration / 60);
              xAxis.push(element.filter_timestamp);
              yAxisView.push(element.video_views);
              xAxisView.push(element.filter_timestamp);
            });

            yAxis = yAxis.reverse();
            xAxis = xAxis.reverse();
            yAxisView = yAxisView.reverse();
            xAxisView = xAxisView.reverse();

            setvodanalyticsReportGraphData({ xAxis, yAxis });
            setvodanalyticsViewReportGraphData({ xAxisView, yAxisView });
          } else {
            setvodanalyticsReportGraphData({ xAxis: [], yAxis: [] });
            setvodanalyticsViewReportGraphData({ xAxisView: [], yAxisView: [] });
            console.error("No graph data returned from API");
          }
          setLoader(false);
        })
        .catch((error) => {
          console.error("Error fetching graph data:", error);
          setvodanalyticsReportGraphData({ xAxis: [], yAxis: [] });
          setvodanalyticsViewReportGraphData({ xAxisView: [], yAxisView: [] });
          setLoader(false);
        });
    }

    setActiveTrigger(false);
  };

  const fileName = "TechnicalAdda";

  const paginate = (number) => {
    setCurrentPage(number);
    console.log(currentPage);
  };

  const [App, setApp] = useState(false);
  const [Channel, setChannels] = useState(false);
  const [Country, setCountry] = useState(false);
  const [contentPartnerSelected, setContentPartnerSelected] = useState(false);

  const [shows, setShows] = useState(false);
  const [videos, setVideos] = useState(false);
  const [collections, setCollections] = useState(false);
  const [episodes, setEpisodes] = useState(false);
  const [collectionVideos, setCollectionVideos] = useState(false);
  ///filter datas

  const [key, setKey] = useState("Duration");
  const [countryList, setCountryList] = useState([]);
  const [channel, setChannel] = useState([]);
  const [publishers, setPublishers] = useState([]);
  const [appType, setAppType] = useState([]);
  const [show, setShow] = useState([]);
  const [video, setVideo] = useState([]);
  const [collection, setCollection] = useState([]);
  const [episode, setEpisode] = useState([]);
  const [collectionVideo, setCollectionVideo] = useState([]);

  ////pagination variables/////

  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(200);

  //excel data

  const [exelData, setExcelData] = useState([]); const [filter, setFilter] = useState({
    start_date: moment(dateRange[0].startDate).format("YYYY-MM-DD"),
    end_date: moment(dateRange[0].endDate).format("YYYY-MM-DD"),
    country: null,
    channel: null,
    appType: null,
    paymentMode: null,
    publishers: null,
    subType: null,
    show: null,
    video: null,
    collection: null,
    episode: null,
    collectionVideo: null,
    contentPartner: null,
    isChannelsSelected: false,
    isChannelSelected: false,
    isCountrySelected: false,
    isAppSelected: false,
    isPublisherSelected: false,
    isVideoChecked: false,
    isCitySelected: false,
    isShowchecked: false,
    isCollectionchecked: false,
    isEpisodeChecked: false,
    isCollectionVideoChecked: false,
    city: null,
    isMonthlySelected: false,
    isAggregateSelected: false,
    isMediaIdSelected: false,
    // aggregate
  });

  const selectedFilterByLabel = [
    filter?.isMonthlySelected ? "Monthly" : null,
    filter?.isAggregateSelected ? "Aggregate" : null,
    filter?.isMediaIdSelected ? "Media Id" : null,
  ].filter(Boolean).join(", ");

  const filterByOptions = [
    { value: "monthly", label: "Monthly" },
    { value: "aggregate", label: "Aggregate" },
    { value: "mediaId", label: "Media Id" },
  ];

  const selectedFilterByOptions = filterByOptions.filter(({ value }) => {
    if (value === "monthly") return filter?.isMonthlySelected;
    if (value === "aggregate") return filter?.isAggregateSelected;
    if (value === "mediaId") return filter?.isMediaIdSelected;
    return false;
  });

  const handleFilterByChange = (selectedOptions, actionMeta) => {
    const selectedValues = (selectedOptions || []).map((option) => option.value);
    let normalizedValues = [...selectedValues];

    if (
      normalizedValues.includes("monthly") &&
      normalizedValues.includes("aggregate")
    ) {
      if (actionMeta?.option?.value === "monthly") {
        normalizedValues = normalizedValues.filter((value) => value !== "aggregate");
      } else if (actionMeta?.option?.value === "aggregate") {
        normalizedValues = normalizedValues.filter((value) => value !== "monthly");
      } else {
        normalizedValues = normalizedValues.filter((value) => value !== "aggregate");
      }
    }

    setFilter({
      ...filter,
      isMonthlySelected: normalizedValues.includes("monthly"),
      isAggregateSelected: normalizedValues.includes("aggregate"),
      isMediaIdSelected: normalizedValues.includes("mediaId"),
    });
  };

  const options = {
    custom: true,
    sizePerPage: 200,
    totalSize: vodanalyticsReport.length,
  };

  const handleNextPage =
    ({ page, onPageChange }) =>
      () => {
        onPageChange(page + 1);
      };

  const handlePrevPage =
    ({ page, onPageChange }) =>
      () => {
        onPageChange(page - 1);
      };
  const handleFirstPage =
    ({ page, onPageChange }) =>
      () => {
        onPageChange(1);
      };

  const handleLastPage =
    ({ sizePerPage, onPageChange, totalSize }) =>
      () => {
        onPageChange(Math.ceil(totalSize / sizePerPage));
      };
  const CustomTotal = ({ sizePerPage, totalSize, page, lastIndex }) => (
    <span>
      {(page - 1) * sizePerPage + 1} to{" "}
      {lastIndex > totalSize ? totalSize : lastIndex} of {totalSize}
    </span>
  );
  const publisherCheck = () => {
    if (localStorage.getItem("role_id") == 7) {
      return true;
    } else return false;
  };
  const columns = [
    {
      dataField: "filter_timestamp",
      text: "Date",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",
      headerAlign: "left",
      footerAlign: "left",
      footer: "",
      hidden: hideColumn ? true : false,
      // aggregate
    },
    {
      dataField: "publisherName",
      text: "Publisher Name",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",
      headerAlign: "left",
      footer: "",
      hidden: !publisherCheck(),
    },
    {
      dataField: "country",
      text: "Country",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",
      headerAlign: "left",
      hidden: !Country,
      footer: "",
    },
    {
      dataField: "city",
      text: "City",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      footer: "",
      hidden:
        vodanalyticsReport.length !== 0 && vodanalyticsReport[0].city
          ? false
          : true,
    },
    {
      dataField: "appName",
      text: "App",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",
      hidden: !App,
      headerAlign: "left",
      footer: "",
    },
    {
      dataField: "channelName",
      text: "Channel",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",
      hidden: !showChannelColum,
      headerAlign: "left",
      footer: "",
    },
    {
      dataField: "content_partner_name",
      text: "Content Partner",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      footer: "",
      hidden: !contentPartnerSelected,
    },
    {
      dataField: "video_title",
      text: "Video",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",
      hidden: !videos,
      headerAlign: "left",
      footer: "",
    },
    {
      dataField: "video_title",
      text: "Episode",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",
      hidden: !episodes,
      headerAlign: "left",
      footer: "",
    },
    {
      dataField: "video_title",
      text: "Collection Video",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",
      hidden: !collectionVideos,
      headerAlign: "left",
      footer: "",
    },
    {
      dataField: "show_name",
      text: "Show",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",
      hidden: !shows,
      headerAlign: "left",
      footer: "",
    },
    {
      dataField: "show_name",
      text: "Collection",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",
      hidden: !collections,
      headerAlign: "left",
      footer: "",
    },
    {
      dataField: "mediaId",
      text: "Media Id",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",
      hidden: !shows,
      headerAlign: "left",
      footer: "",
      hidden: !mediaId,
    },

    {
      dataField: "video_views",
      text: "Views",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",

      headerAlign: "left",
      footer: (data) => {
        return summary.views === null ? 0 : summary.views;
      },
      // footer: columnData => {
      //     let sum = 0;

      //     for (let num of columnData) {

      //            //num = parseFloat(num.toString().replace(/[\s,]+/g, '').trim());
      //         sum = sum + num
      //     }
      //     //   setimp(sum);
      //     return sum;}
    },
    {
      dataField: "duration",
      text: "Viewed Minutes",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      align: "left",
      headerAlign: "left",
      footerAlign: "left",
      formatter: (duration) => {
        return Math.round((duration / 60) * 100) / 100;
      },
      footer: (data) => {
        return summary.minutes === null ? 0 : summary.minutes.toFixed(2);
      }
    },
  ];
  useEffect(() => {
    channelFilterColumnConfig();
    filters.getCountryList().then((response) => {
      let data = [{ value: 1, label: "All" }];
      {
        let index = 2;
        response.data &&
          response.data.map((element) => {
            data.push({
              value: index,
              label: element.country_name,
              code: element.code,
            });
            index = index + 1;
          });
      }
      setCountryList(data);
    });

    filters.getChannelList(localStorage.getItem("pub_id")).then((response) => {
      let data = [];
      {
        let index = 1;
        response.data &&
          response.data.map((element) => {
            data.push({
              value: index,
              label: element.channel_name,
              channel_id: element.channel_id,
            });
            index = index + 1;
          });
      }
      {
        globalChannelConfig(data); // //// Global channel config /////////////
      }
    });
    filters
      .getPublishersList(localStorage.getItem("pub_id"))
      .then((response) => {
        let data = [{ value: 1, label: "All" }];
        {
          let index = 2;
          response.data &&
            response.data.map((element) => {
              data.push({
                value: index,
                label: element.name,
                pubid: element.pubid,
              });
              index = index + 1;
            });
        }
        setPublishers(data);
      });

    service
      .getShowList(localStorage.getItem("pub_id"))
      .then((response) => {
        console.log("show list", response);
        let data = [{ value: 1, label: "All" }];
        {
          let index = 2;
          response.data &&
            response.data.map((element) => {
              data.push({
                value: index,
                label: element.show_name,
                id: element.show_id,
              });
              index = index + 1;
            });
        }
        setShow(data);
      });

    service
      .getCollectionList(localStorage.getItem("pub_id"))
      .then((response) => {
        let data = [{ value: 1, label: "All" }];
        {
          let index = 2;
          response.data &&
            response.data.map((element) => {
              data.push({
                value: index,
                label: element.show_name,
                id: element.show_id,
              });
              index = index + 1;
            });
        }
        setCollection(data);
      });


    service
      .getEpisodeList(localStorage.getItem("pub_id"))
      .then((response) => {
        let data = [{ value: 1, label: "All" }];
        {
          let index = 2;
          response.data &&
            response.data.map((element) => {
              data.push({
                value: index,
                label: element.video_title,
                id: element.video_id,
              });
              index = index + 1;
            });
        }
        setEpisode(data);
      });

    service
      .getCollectionVideoList(localStorage.getItem("pub_id"))
      .then((response) => {
        let data = [{ value: 1, label: "All" }];
        let index = 2;
        response.data &&
          response.data.map((element) => {
            data.push({
              value: index,
              label: element.video_title,
              id: element.video_id,
            });
            index = index + 1;
          });
        setCollectionVideo(data);
      });

    service
      .getVideoList(localStorage.getItem("pub_id"))
      .then((response) => {
        console.log("video list", response);
        let data = [{ value: 1, label: "All" }];
        {
          let index = 2;
          response.data &&
            response.data.map((element) => {
              data.push({
                value: index,
                label: element.video_title,
                id: element.video_id,
              });
              index = index + 1;
            });
        }
        setVideo(data);
      });
  }, []);
  useEffect(() => {

    service
      .getShowList(localStorage.getItem("pub_id"))
      .then((response) => {
        console.log("show list", response);
        let data = [{ value: 1, label: "All" }];
        {
          let index = 2;
          response.data &&
            response.data.map((element) => {
              data.push({
                value: index,
                label: element.show_name,
                id: element.show_id,
              });
              index = index + 1;
            });
        }
        setShow(data);
      });

    service
      .getVideoList(localStorage.getItem("pub_id"))
      .then((response) => {
        console.log("video list", response);
        let data = [{ value: 1, label: "All" }];
        {
          let index = 2;
          response.data &&
            response.data.map((element) => {
              data.push({
                value: index,
                label: element.video_title,
                id: element.video_id,
              });
              index = index + 1;
            });
        }
        setVideo(data);
      });
  }, [filter.channel]);

  useEffect(() => {
    let data = [];
    let summary = { minutes: 0, views: 0 };
    vodanalyticsReport.map((element) => {
      let appdata = {
        "Date": element.filter_timestamp || "",
        "APP": element.appName || "",
        "Channel": element.channelName || "",
        "content_partner": element.content_partner_name || "",
        "Country": element.country || "",
        "City": element.city || "",
        "Publisher Name": element.publisherName || "",
        "Show": element.showName || element.show_name || "",
        "Video": element.video_title || "",
        "content Partner": element.content_partner_name || "",
        "Category Name": element.category_name || "",
        "Total Viewed Minutes": element.duration
          ? parseFloat((element.duration / 60).toFixed(2))
          : "",
        "Video Views": element.video_views || "",
        "Media id": element.mediaId || "",
      };
      appdata = Object.fromEntries(
        Object.entries(appdata).filter(([_, value]) => value !== "")
      );

      if (element.duration) {
        summary.minutes += parseFloat((element.duration / 60).toFixed(2));
      }

      if (element.video_views) {
        summary.views += parseInt(element.video_views);
      }
      data.push(appdata);
    });
    setSummary(summary);

    setExcelData(data);
  }, [vodanalyticsReport]);

  const indexOfLasrtPost = currentPage * postPerPage;
  const indexOfFirstPost = indexOfLasrtPost - postPerPage;
  const currentPosts = vodanalyticsReport.slice(
    indexOfFirstPost,
    indexOfLasrtPost
  );

  var [update, setUpdate] = useState(true);
  const weekly_monthly_filter = (start_date, end_date, W_M_Flag) => {
    console.log("lidhish testing", start_date, end_date, W_M_Flag);
    setLoader(true);

    setNewFilter({
      ...filter,
      start_date,
      end_date,
    });

    if (flag) {
      setUpdate(!update);
    }
  };

  useEffect(() => {
    if (flag) {
      service
        .VodAnalyticsReportGraph(
          localStorage.getItem("pub_id"),
          [filter.channel],
          filterNew,
          user_id
        )
        .then((response) => {
          //  console.log("..........response  grapgh jjjj",response)
          let xAxis = [];
          let yAxis = [];
          let xAxisView = [];
          let yAxisView = [];

          {
            response.data &&
              response.data.map((element) => {
                yAxis.push(element.duration / 60);
                xAxis.push(element.filter_timestamp);
                yAxisView.push(element.video_views);
                xAxisView.push(element.filter_timestamp);
              });
            yAxis = yAxis.reverse();
            xAxis = xAxis.reverse();
            yAxisView = yAxisView.reverse();
            xAxisView = xAxisView.reverse();
          }

          setvodanalyticsReportGraphData({
            xAxis,
            yAxis,
          });
          setvodanalyticsViewReportGraphData({
            xAxisView,
            yAxisView,
          });
          setLoader(false);
        });
    }
  }, [update]);

  useEffect(() => {
    if (!filter.channel || !filter.channel.channel_id) {
      setAppType([{ value: 1, label: "All" }]);
      setFilter(prevFilter => ({
        ...prevFilter,
        appType: null
      }));
      return;
    }

    setAppType([{ value: 1, label: "Loading...", isDisabled: true }]);
    filters
      .getAppType(localStorage.getItem("pub_id"), filter.channel?.channel_id)
      .then((response) => {
        if (response && response.data) {
          let data = [{ value: 1, label: "All" }];
          let index = 2;

          response.data.forEach((element) => {
            data.push({
              value: index,
              label: element.app_name,
              app_type: element.app_type,
              id: element.id,
            });
            index++;
          });

          setAppType(data);
        } else {
          setAppType([{ value: 1, label: "All" }]);
        }
      })
      .catch((error) => {
        console.error("Error fetching app types:", error);
        setAppType([{ value: 1, label: "All" }]);
      });
    service
      .getContentPartner(filter.channel?.channel_id)
      .then((response) => {
        if (response && response.data) {
          let data = [{ value: 1, label: "All" }];
          let index = 2;

          response.data.forEach((element) => {
            data.push({
              value: index,
              label: element.name,
              content_partner_id: element.publisher_users_id,
            });
            index++;
          });

          setContentPartnerList(data);
        } else {
          setContentPartnerList([{ value: 1, label: "All" }]);
        }
      })
      .catch((error) => {
        console.error("Error fetching content partners:", error);
        setContentPartnerList([{ value: 1, label: "All" }]);
      });
  }, [filter.channel]);

  useEffect(() => {
    if (flag) {
      setTimeout(() => {
        if (filter.channel.channel_id) {
          service
            .VodAnalyticsReportGraph(
              localStorage.getItem("pub_id"),
              [filter.channel],
              filter,
              user_id
            )
            .then((response) => {
              let xAxis = [];
              let yAxis = [];
              let xAxisView = [];
              let yAxisView = [];

              {
                response.data &&
                  response.data.map((element) => {
                    yAxis.push(element.duration / 60);
                    xAxis.push(element.filter_timestamp);
                    yAxisView.push(element.video_views);
                    xAxisView.push(element.filter_timestamp);
                  });
                yAxis = yAxis.reverse();
                xAxis = xAxis.reverse();
                yAxisView = yAxisView.reverse();
                xAxisView = xAxisView.reverse();
              }

              setvodanalyticsReportGraphData({
                xAxis,
                yAxis,
              });
              setvodanalyticsViewReportGraphData({
                xAxisView,
                yAxisView,
              });
              setLoader(false);
            });

          service
            .VodAnalyticsReportDefault(localStorage.getItem("pub_id"), [
              filter.channel,
            ], user_id)
            .then((response) => {
              let data = [];
              {
                response.data && setvodanalyticsReport(response.data);
                // setSummary(response.duration)
                setLoaderTable(false);
              }
            });
        } else {
          service
            .VodAnalyticsReportGraph(
              localStorage.getItem("pub_id"),
              channel,
              filter,
              user_id
            )
            .then((response) => {
              console.log("..........response  grapgh jjjj", response);
              let xAxis = [];
              let yAxis = [];
              let xAxisView = [];
              let yAxisView = [];

              {
                response.data &&
                  response.data.map((element) => {
                    yAxis.push(element.duration / 60);
                    xAxis.push(element.filter_timestamp);
                    yAxisView.push(element.video_views);
                    xAxisView.push(element.filter_timestamp);
                  });
                yAxis = yAxis.reverse();
                xAxis = xAxis.reverse();
                yAxisView = yAxisView.reverse();
                xAxisView = xAxisView.reverse();
              }

              setvodanalyticsReportGraphData({
                xAxis,
                yAxis,
              });
              setvodanalyticsViewReportGraphData({
                xAxisView,
                yAxisView,
              });
              setLoader(false);
            });

          service
            .VodAnalyticsReportDefault(localStorage.getItem("pub_id"), channel, user_id)
            .then((response) => {
              let data = [];
              {
                response.data && setvodanalyticsReport(response.data);
                // setSummary(response.duration)
                setLoaderTable(false);
              }
            });
        }
      }, 1000);
    }
    setFlag(true); // to eliminate virutual dom suddenly updating problem
  }, [channel]);

  //New date widget start
  const [calenderOpen, setCalenderOpen] = useState(false);
  const [state, setState] = useState([
    {
      endDate: new Date(),
      startDate: addDays(new Date(), -6),
      key: "selection",
    },
  ]);

  function initialDateFormatterrr(date, day) {
    var date1 = dateFormatter.format(date, "MM-DD-YYYY");
    return date1;
  }

  useEffect(() => {
    let cl = document.getElementsByClassName("rdrStaticRange");
    Array.from(cl).forEach((element, index) => {
      element.id = `id${index}`;
    });
    let x = document.createElement("div");
    x.innerHTML = "Cancel";
    x.className = "btn btn-danger";
    x.onclick = function () {
      setState([
        {
          endDate: state?.[0].endDate,
          startDate: state?.[0].startDate,
          key: "selection",
        },
      ]);
      if (
        filter.start_date == initialDateFormatterrr(state?.[0].startDate, 0) ||
        filter.end_date == initialDateFormatterrr(state?.[0].endDate, 0)
      ) {
        setCalenderOpen(false);
      }
    };

    let dateCalender = document.getElementsByClassName(
      "rdrMonths rdrMonthsVertical"
    );
    console.log(
      Array.from(dateCalender).childNodes,
      Array.from(dateCalender).length
    );
    Array.from(dateCalender).forEach((el) => {
      el.insertAdjacentElement("afterend", x);
      return;
    });
  }, [calenderOpen]);

  //New date widget End

  const getPublisherConfigInfo = keyName => {
    let response = false;
    if (localStorage.getItem("publisherConfig") && (typeof localStorage.getItem("publisherConfig") !== 'undefined' && (localStorage.getItem("publisherConfig") !== 'undefined'))) {
      var publisherConfig = JSON.parse(localStorage.getItem("publisherConfig"));
      if (publisherConfig && publisherConfig?.length > 0) {
        let configInfo = publisherConfig.filter(i => keyName == i.key_name);
        response = configInfo[0] && configInfo[0].key_value;
        return response;
      }
    }
    return response;
  };

  return (
    <Fragment>
      <Container className="body-inner-wrapper" style={{ border: 'none', marginTop: '2rem' }}>
        <div className="bread-crumbs-container col-lg-12 analytics mb-4">
          <div className="bread-crumbs border-0">
            <div className="heading pl-1 pt-2 ml-3">
              <Breadcrumb
                items={
                  report
                    ? [
                        { label: "Analytics" },
                        { label: "Viewership", to: "/new-analytics/viewership" },
                        {
                          label: "User Details Report",
                          to: {
                            pathname: returnPath,
                            state: returnState ? { userDetailReportState: returnState } : undefined,
                          },
                        },
                      ]
                    : (groupMemberView
                      ? [
                          { label: "My Group" },
                          { label: "Members", to: "/group/members" },
                        ]
                      : [
                          { label: "User Management" },
                          { label: "User List", to: "/operations/UserManagment" },
                        ])
                }
              />
              <h1>User Analytics - For {name}</h1>
            </div>
            <div>
              <Link
                to={{
                  pathname: returnPath,
                  state: returnState ? { userDetailReportState: returnState } : undefined,
                }}
              ><Button className="btn btn-primary m-1 cancel-btn">Cancel</Button></Link>
            </div>
          </div>
        </div>
        <Container className="body-inner-wrapper devider analytics"></Container>
        <Row
          style={{ display: "flex", justifyContent: "flex-end" }}
          noGutters
        >
          <FilterItems
            filterFunction={weekly_monthly_filter}
            start_date={filter.start_date}
            end_date={filter.end_date}
            triger={triger}
          />
        </Row>
        <Card className="p-0">
          <CardBody className="bg-light analytics-body p-0">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className=""
            >
              <Tab eventKey="Duration" title="Duration" className="">
                {loader ? (
                  <Loader />
                ) : (
                  <Pointgraph
                    dataName="Viewed Duration in Minutes"
                    title={""}
                    xAxis={vodanalyticsReportGraphData.xAxis}
                    yAxis={vodanalyticsReportGraphData.yAxis}
                    showXAxisLabels={true}
                  />
                )}
              </Tab>
              <Tab eventKey="View" title="Views" className="">
                {loader ? (
                  <Loader />
                ) : (
                  <Pointgraph
                    dataName="Views"
                    title={""}
                    xAxis={vodanalyticsViewReportGraphData.xAxisView}
                    yAxis={vodanalyticsViewReportGraphData.yAxisView}
                    showXAxisLabels={true}
                  />
                )}
              </Tab>
            </Tabs>
          </CardBody>
        </Card>

        <CardBody className="bg-light analytics-body mt-4">
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <FiltersRow>
                {[
                  <DateRange
                    dateRange={dateRange}
                    onChange={(range) => {
                      setDateRange(range);
                    }}
                  />,
                  <ReactSelect
                    value={filter.country}
                    onChange={(value) =>
                      setFilter({
                        ...filter,
                        country: value,
                        isCountrySelected: value !== null,
                        city: null,
                        isCitySelected: false
                      })
                    }
                    options={countryList}
                    placeholder="Country"
                    isClearable={true}
                  />,
                  <SearchCity
                    country={filter.country}
                    value={filter.city}
                    onChange={(value) =>
                      setFilter({
                        ...filter,
                        city: value,
                        isCitySelected: value !== null
                      })
                    }
                    placeholder="Search City"
                    isClearable
                  />,
                  <ReactSelect
                    value={filter.appType}
                    onChange={(value) => {
                      setFilter({ ...filter, appType: value, isAppSelected: value !== null });
                    }}
                    options={appType}
                    placeholder="App"
                    isClearable={true}
                  />,
                  <ReactSelect
                    value={filter.show}
                    onChange={(value) => {
                      const newFilterState = {
                        ...filter,
                        show: value,
                        isShowchecked: value !== null,
                      };
                      setFilter(newFilterState);
                    }}
                    options={show}
                    placeholder="Show"
                    isClearable={true}
                    isDisabled={!filter.channel}
                  />,
                  <ReactSelect
                    value={filter.episode}
                    onChange={(value) => {
                      const newFilterState = {
                        ...filter,
                        episode: value,
                        isEpisodeChecked: value !== null,
                      };
                      setFilter(newFilterState);
                    }}
                    options={episode}
                    placeholder="Episode"
                    isClearable={true}
                    isDisabled={!filter.channel}
                  />,
                  getPublisherConfigInfo("collection_needed") == "True" ?
                    <ReactSelect
                      value={filter.collection}
                      onChange={(value) => {
                        const newFilterState = {
                          ...filter,
                          collection: value,
                          isCollectionchecked: value !== null,
                        };
                        setFilter(newFilterState);
                      }}
                      options={collection}
                      placeholder="Collection"
                      isClearable={true}
                      isDisabled={!filter.channel}
                    /> : null,
                  getPublisherConfigInfo("collection_needed") == "True" ?
                    <ReactSelect
                      value={filter.collectionVideo}
                      onChange={(value) => {
                        const newFilterState = {
                          ...filter,
                          collectionVideo: value,
                          isCollectionVideoChecked: value !== null,
                        };
                        setFilter(newFilterState);
                      }}
                      options={collectionVideo}
                      placeholder="Collection Video"
                      isClearable={true}
                      isDisabled={!filter.channel}
                    />
                    : null,
                    <ReactSelect
                    value={filter.video}
                    onChange={(value) => {
                      const newFilterState = {
                        ...filter,
                        video: value,
                        isVideoChecked: value !== null,
                      };
                      setFilter(newFilterState);
                    }}
                    options={video}
                    placeholder="Video"
                    isClearable={true}
                    isDisabled={!filter.channel}
                  />,
                  (getChannelConfigInfo("content_partner_needed") == "True" && localStorage.getItem("role_id") != 8) ? <ReactSelect
                    value={filter.contentPartner}
                    onChange={(value) => {
                      setFilter({
                        ...filter,
                        contentPartner: value,
                        isContentPartnerSelected: value !== null
                      });
                    }}
                    options={contentPartnerList}
                    placeholder="Content Partner"
                    isClearable={true}
                    isDisabled={!filter.channel}
                  /> : null,
                  <div style={{ minWidth: "190px" }}>
                    <ReactSelect
                      value={selectedFilterByOptions}
                      onChange={handleFilterByChange}
                      options={filterByOptions}
                      placeholder={selectedFilterByLabel ? `Filter By : ${selectedFilterByLabel}` : "Filter By"}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      isClearable
                      controlShouldRenderValue={false}
                      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                      styles={{
                        container: (base) => ({
                          ...base,
                          minWidth: "190px",
                        }),
                        control: (base) => ({
                          ...base,
                          minHeight: "38px",
                          borderColor: "#cfd6e6",
                          boxShadow: "none",
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          whiteSpace: "nowrap",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          color: "#444",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 1050,
                        }),
                      }}
                    />
                  </div>,
                  <div className="d-flex">
                    <Button type="submit" color="primary" className="w-100">
                      Apply Filter
                    </Button>
                    <ExportCSV
                      className="ml-2"
                      csvData={exelData}
                      fileName={"VOD analytics Reports"}
                      isDisable={vodanalyticsReport.length === 0}
                    />
                  </div>
                ]}
              </FiltersRow>
            </FormGroup>

            {loaderTable ? (
              <Loader />
            ) : vodanalyticsReport.length !== 0 ? (
              <Fragment>
                <Row noGutters style={{ margin: "1rem 0 0 0" }}>
                  <Col md={12} className="pr-lg-3">
                    <CardBody>
                      <PaginationProvider
                        pagination={paginationFactory(options)}
                      >
                        {({ paginationProps, paginationTableProps }) => {
                          const lastIndex =
                            paginationProps.page * paginationProps.sizePerPage;

                          return (
                            <Fragment>
                              <div className="table-responsive new-table">
                                <BootstrapTable
                                  bootstrap4={true}
                                  id="excel"
                                  keyField="id"
                                  data={vodanalyticsReport.map(
                                    (element, index) => {
                                      return { ...element, slno: index + 1 };
                                    }
                                  )}
                                  columns={columns}
                                  bordered={true}
                                  condensed={true}
                                  hover={true}
                                  tabIndexCell={true}
                                  striped={true}
                                  search={true}
                                  expanded={true}
                                  expandable={true}
                                  searchable={true}
                                  footer={true}
                                  classes="table-dashboard table-sm fs--1 border-bottom border-200 mb-0 table-dashboard-th-nowrap"
                                  rowClasses="btn-reveal-trigger border-top border-200"
                                  headerClasses="bg-200 text-900 border-y border-200"
                                  {...paginationTableProps}
                                />
                              </div>
                              <Row noGutters className="px-1 py-3">
                                <Col className="pl-3 fs--1">
                                  <CustomTotal
                                    {...paginationProps}
                                    lastIndex={lastIndex}
                                  />
                                </Col>
                                <Col xs="auto" className="pr-1">
                                  <Button
                                    color={
                                      paginationProps.page === 1
                                        ? "light"
                                        : "primary"
                                    }
                                    size="sm"
                                    onClick={handleFirstPage(paginationProps)}
                                    disabled={paginationProps.page === 1}
                                    className="px-4 ml-2"
                                  >
                                    First
                                  </Button>

                                  <Button
                                    color={
                                      paginationProps.page === 1
                                        ? "light"
                                        : "primary"
                                    }
                                    size="sm"
                                    onClick={handlePrevPage(paginationProps)}
                                    disabled={paginationProps.page === 1}
                                    className="px-4 ml-2"
                                  >
                                    Previous
                                  </Button>
                                  <Button
                                    color={
                                      lastIndex >= paginationProps.totalSize
                                        ? "light"
                                        : "primary"
                                    }
                                    size="sm"
                                    onClick={handleNextPage(paginationProps)}
                                    disabled={
                                      lastIndex >= paginationProps.totalSize
                                    }
                                    className="px-4 ml-2"
                                  >
                                    Next{" "}
                                  </Button>
                                  <Button
                                    color={
                                      lastIndex >= paginationProps.totalSize
                                        ? "light"
                                        : "primary"
                                    }
                                    size="sm"
                                    onClick={handleLastPage(paginationProps)}
                                    disabled={
                                      lastIndex >= paginationProps.totalSize
                                    }
                                    className="px-4 ml-2"
                                  >
                                    Last
                                  </Button>
                                </Col>
                              </Row>
                            </Fragment>
                          );
                        }}
                      </PaginationProvider>
                    </CardBody>
                  </Col>
                </Row>
              </Fragment>
            ) : (
              <p>
                <h3 className="text-center entire-width">
                  <span>No data Available !</span>
                </h3>
              </p>
            )}
          </Form>
        </CardBody>
      </Container>
    </Fragment>
  );
};

export default UserAnalytics;
